/**
 * 世界状态构建：汇总各已注册页面能力的上下文 + 应用级记忆/路由状态，
 * 构造 v2 聊天请求的 context（沿用 AgentMapContext 形状）。
 */
import type { AgentCapabilityRegistry } from "@/agent/AgentCapabilityRegistry";
import type { AgentMapContext } from "@/services/api/agentApi";

export interface AgentMemorySnapshot {
  lastBuildingId: string;
  lastBuildingName: string;
  recentTurns: Array<{ role: "user" | "assistant"; content: string }>;
}

export interface WorldStateBuildExtras {
  routeName?: string | null;
  routePath?: string | null;
  routeBuildingId?: string | null;
  memory: AgentMemorySnapshot;
  routeResult?: {
    activeRouteId?: string;
    stopIds?: string[];
    distanceMeters?: number;
    durationMinutes?: number;
    routePreference?: string;
    routeRendered?: boolean;
  } | null;
}

export class AgentWorldStateBuilder {
  constructor(private readonly registry: AgentCapabilityRegistry) {}

  build(extras: WorldStateBuildExtras): AgentMapContext {
    const context: AgentMapContext = {};
    for (const capability of this.registry.getAll()) {
      try {
        const partial = capability.buildContext();
        if (partial && typeof partial === "object") {
          Object.assign(context, partial);
        }
      } catch {
        // 单个页面上下文失败不阻断整体
      }
    }
    return {
      ...context,
      selectedBuildingId: context.selectedBuildingId || extras.routeBuildingId || null,
      lastMentionedBuildingId:
        context.lastMentionedBuildingId || extras.memory.lastBuildingId || extras.routeBuildingId || null,
      lastMentionedBuildingName:
        context.lastMentionedBuildingName || extras.memory.lastBuildingName || null,
      recentMessages: extras.memory.recentTurns.slice(-8),
      activeRouteId: extras.routeResult?.activeRouteId || context.activeRouteId || null,
      routeName: extras.routeName ?? context.routeName ?? null,
      routePath: extras.routePath ?? context.routePath ?? null
    };
  }
}
